import { Col, Row } from "reactstrap"
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import GrayHeading from "../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import { HiDownload } from "react-icons/hi"
import PDFIcon from "../../../../../assets/images/AdminPortal/PricingFinance/pdf.png"
import WordIcon from "../../../../../assets/images/AdminPortal/PricingFinance/word.png"
import FileImageIcon from "../../../../../assets/images/AdminPortal/PricingFinance/image-file.png"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"

const FileContainer = ({ label, icon }) => {
  return (
    <div className="border border-secondary rounded">
      <div className="d-flex">
        <div className="flex-grow-1 flex-shrink-1 border-end d-flex gap-3 align-items-center p-2">
          <div>
            <img src={icon} alt="" width={25} height={25} />
          </div>
          <div>{label}</div>
        </div>
        <div className="d-flex align-items-center justify-content-center px-2">
          {/* <button style={{ all: "unset" }}> */}
            <HiDownload size={24} />
          {/* </button> */}
        </div>
      </div>
    </div>
  )
}

const LoanDetail = ({ setShowLoanDetail }) => {
  const attachmentsData = [
    { label: "file name here.pdf", icon: PDFIcon },
    { label: "file name here.word", icon: WordIcon },
    { label: "file name here.jpg", icon: FileImageIcon },
  ]

  const paymentScheduleData = [
    { installment: "1", dueDate: "06/12/2025", amountDue: "$1,000", status: "Paid" },
    { installment: "1", dueDate: "06/12/2025", amountDue: "$1,000", status: "Due" },
  ]

  const paymentScheduleColumns = [
    { name: "Installment", selector: (row) => row.installment },
    { name: "Due Date", selector: (row) => row.dueDate },
    { name: "Amount Due", selector: (row) => row.amountDue },
    { name: "Status", selector: (row) => row.status },
  ]

  return (
    <div className="bg-white shadow px-4 p-3 mt-3">
      <ComponentBackButton onClick={() => setShowLoanDetail((prev) => !prev)} />
      <div className="d-flex justify-content-center mb-3">
        <GrayHeading>Loan Detail</GrayHeading>
      </div>

      <Row className="row-cols-1 row-cols-lg-2">
        <Col className="d-grid">
          <div className="shadow rounded p-4">
            <div className="fs-5 fw-medium mb-3">Basic Information</div>

            <div style={{ backgroundColor: "#FBBD345E" }} className="p-2 rounded mb-3">
              <Row className="g-0">
                <Row className="g-0">
                  <Col>
                    <Row className="g-0">
                      <Col className="fs-medium">Loan ID:</Col>
                      <Col>#001</Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row className="g-0">
                      <Col className="fs-medium">Loan Type:</Col>
                      <Col>Short-term</Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="g-0">
                  <Col>
                    <Row className="g-0">
                      <Col className="fs-medium">Seller ID:</Col>
                      <Col>#23423</Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row className="g-0">
                      <Col className="fs-medium">Seller Name:</Col>
                      <Col>John Doe</Col>
                    </Row>
                  </Col>
                </Row>
              </Row>
            </div>

            <Row className="g-0">
              <Col xs="6" lg="3">
                Loan Amount:
              </Col>
              <Col>$10,000</Col>
            </Row>

            <Row className="g-0">
              <Col xs="6" lg="3">
                Status:
              </Col>
              <Col>Active</Col>
            </Row>

            <Row className="g-0 mt-3">
              <Col xs="12" lg="7" className="border border-warning rounded p-2">
                <Row className="g-0">
                  <Col>Rebursement date:</Col>
                  <Col>05/12/2024</Col>
                </Row>
                <Row className="g-0">
                  <Col>Remaining Balance:</Col>
                  <Col>$7,000</Col>
                </Row>
                <Row className="g-0">
                  <Col>Next Payment date:</Col>
                  <Col>07/12/2024</Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
        <Col className="d-grid">
          <div className="shadow rounded p-4">
            <div className="fs-5 fw-medium mb-3">Attached Documents</div>
            <div className="d-flex flex-column gap-2">
              {attachmentsData.map((item, index) => (
                <FileContainer key={index} label={item.label} icon={item.icon} />
              ))}
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          <div className="shadow rounded p-4">
            <div className="mb-3 fs-5 fw-medium">Repayment Schedule</div>
            <DynamicDatatable data={paymentScheduleData} columns={paymentScheduleColumns} type="yellow" />
          </div>
        </Col>
        <Col className="d-flex align-items-center justify-content-center align-items-md-end justify-content-md-end">
          <div className="mt-3 mt-lg-0">
            <DynamicButton theme="orange">Notify Seller</DynamicButton>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default LoanDetail
